<template>
  <OnboardingStep :commit="commit">
	<template #heading>
		<h1 class="onboarding-step-heading">{{ suggestedPlan ? 'Our Recommendation' : 'The role that best describes me is...' }}</h1>
	</template>
    <template v-if="plans.length">

		<div v-for="plan of plans" :key="`plan-${plan.roleId}`" :class="{'is-suggested': plan === suggestedPlan}" class="plan-radio">
			<input
				type="radio"
				name="plan"
				class="onboarding-plan-input"
				:id="getPlanInputId(plan)"
				:value="plan.roleId"
				:aria-labelledby="getPlanNameId(plan)"
				:aria-describedby="getPlanDescriptionId(plan)"
				:checked="selectedPlan === plan"
				@change="selectedPlan = plan"
				ref="planInputs"
				/>
			<label class="border bg-fff" :for="getPlanInputId(plan)">
				<div class="content">
					<SubscriptionLevelName :level="plan" />
					<p class="fs-14 lh-22 mt-8 mb-0" v-if="getPlanDescription(plan)" :id="getPlanDescriptionId(plan)">
					{{ getPlanDescription(plan) }}
					</p>
					<SubscriptionLevelDetails :level="plan" class="fs-14 button-inline">See Full Description</SubscriptionLevelDetails>
				</div>
			</label>
		</div>
    </template>
    <p v-else>Loading...</p>

    <template #sidebar>
      <div class="onboarding-callout-horizontal card-v2">
        <svg width="73" height="75" viewBox="0 0 73 75" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M33.1553 1.27116C35.0526 -0.423714 37.92 -0.423724 39.8173 1.27116L41.8203 3.06043C43.1023 4.20565 44.8827 4.61201 46.5346 4.13644L49.1155 3.39342C51.5603 2.68959 54.1438 3.93373 55.1178 6.28397L56.1461 8.76511C56.8042 10.3531 58.232 11.4917 59.9267 11.78L62.5744 12.2304C65.0825 12.657 66.8703 14.8989 66.7281 17.439L66.578 20.1206C66.482 21.8369 67.2743 23.4822 68.6761 24.4772L70.8662 26.0318C72.9408 27.5044 73.5789 30.3 72.3487 32.5268L71.0499 34.8777C70.2187 36.3824 70.2187 38.2086 71.05 39.7133L72.3487 42.0642C73.5789 44.291 72.9408 47.0866 70.8662 48.5592L68.6761 50.1138C67.2743 51.1088 66.482 52.7541 66.578 54.4704L66.7281 57.152C66.8703 59.6921 65.0825 61.934 62.5744 62.3606L59.9267 62.811C58.232 63.0993 56.8042 64.2379 56.1461 65.8259L55.1178 68.307C54.1438 70.6573 51.5603 71.9014 49.1155 71.1976L46.5346 70.4546C44.8827 69.979 43.1023 70.3854 41.8203 71.5306L39.8173 73.3198C37.92 75.0147 35.0526 75.0147 33.1553 73.3198L31.1523 71.5306C29.8703 70.3854 28.0899 69.979 26.438 70.4546L23.8571 71.1976C21.4123 71.9014 18.8288 70.6573 17.8548 68.307L16.8265 65.8259C16.1684 64.2379 14.7406 63.0993 13.0459 62.811L10.3982 62.3606C7.89006 61.934 6.10226 59.6921 6.24443 57.152L6.39451 54.4704C6.49057 52.7541 5.69822 51.1088 4.29646 50.1138L2.10634 48.5592C0.0317721 47.0866 -0.606298 44.291 0.623892 42.0642L1.9226 39.7133C2.75384 38.2086 2.75384 36.3824 1.92261 34.8777L0.623892 32.5268C-0.606298 30.3 0.0317721 27.5044 2.10634 26.0318L4.29646 24.4772C5.69823 23.4822 6.49057 21.8369 6.39451 20.1206L6.24443 17.439C6.10226 14.8989 7.89006 12.657 10.3982 12.2304L13.0459 11.78C14.7406 11.4917 16.1684 10.3531 16.8265 8.76511L17.8548 6.28397C18.8288 3.93373 21.4123 2.68959 23.8571 3.39341L26.438 4.13644C28.0899 4.61201 29.8703 4.20565 31.1523 3.06044L33.1553 1.27116Z"
            fill="#009918"
          />
          <circle cx="59" cy="33" r="1" fill="#009918" opacity="0.21" />
          <path
            d="M11.667 41.9523L12.3387 43.7309C14.7442 42.9945 15.4204 41.5329 14.9296 39.5528L12.5986 30.1494L10.3312 30.7114L12.6526 40.076C12.8989 41.0699 12.6341 41.5642 11.667 41.9523ZM20.5665 39.0457C23.0358 38.4336 24.072 36.4294 23.4946 34.0999C22.9191 31.7782 21.0667 30.49 18.5974 31.1021C16.1204 31.7161 15.0842 33.7203 15.6597 36.042C16.2371 38.3715 18.0895 39.6597 20.5665 39.0457ZM17.7174 35.5319C17.394 34.2274 17.9238 33.2389 19.0575 32.9579C20.1834 32.6788 21.1057 33.3074 21.4291 34.6119C21.7544 35.9242 21.2343 36.9185 20.1084 37.1976C18.9747 37.4786 18.0427 36.8442 17.7174 35.5319ZM25.7339 37.6082L27.815 37.0923L25.919 29.4438L23.838 29.9596L25.7339 37.6082ZM23.0949 27.9926C23.2662 28.6837 23.993 29.0888 24.6763 28.9194C25.3752 28.7461 25.8287 28.0485 25.6574 27.3575C25.488 26.6741 24.7612 26.2691 24.0623 26.4423C23.379 26.6117 22.9255 27.3093 23.0949 27.9926ZM33.4804 31.1136L34.5487 35.4232L36.6297 34.9073L35.4171 30.0154C34.9878 28.2838 33.8896 27.3114 31.9561 27.7907C30.6749 28.1083 30.0136 28.9316 29.891 30.0664L29.5001 28.5561L27.6521 29.0142L29.548 36.6627L31.629 36.1469L30.7167 32.4663C30.3548 31.0065 30.8552 30.1324 31.8491 29.886C32.7188 29.6704 33.2206 30.0653 33.4804 31.1136ZM39.7512 25.5535L39.859 25.9883L38.6321 26.2925L39.0672 28.0473L40.294 27.7432L41.7549 33.6369L43.836 33.121L42.375 27.2274L44.4328 26.7173L43.9978 24.9624L41.94 25.4725L41.8188 24.9833C41.6128 24.1524 41.8561 23.7707 42.586 23.5898C42.9587 23.4974 43.3643 23.504 43.7889 23.6213L43.9418 21.9102C43.2456 21.7284 42.6169 21.7524 41.9102 21.9275C40.0078 22.3991 39.2681 23.6045 39.7512 25.5535ZM50.2919 31.6773C52.7611 31.0652 53.7974 29.061 53.2199 26.7315C52.6444 24.4098 50.7921 23.1216 48.3228 23.7337C45.8458 24.3477 44.8095 26.3519 45.3851 28.6737C45.9625 31.0032 47.8148 32.2913 50.2919 31.6773ZM47.4428 28.1636C47.1194 26.8591 47.6491 25.8706 48.7828 25.5896C49.9088 25.3105 50.8311 25.939 51.1545 27.2435C51.4797 28.5558 50.9597 29.5501 49.8338 29.8292C48.7001 30.1103 47.7681 29.4759 47.4428 28.1636ZM55.4496 30.234L57.5151 29.722L56.6624 26.2821C56.2293 24.535 57.3235 23.6291 58.7439 23.5737L58.1877 21.3296C56.7128 21.4315 55.9232 22.402 55.7983 23.7269L55.3804 22.1409L53.5556 22.5932L55.4496 30.234ZM24.0436 55.5417L26.3109 54.9796L25.2773 50.8098L29.0822 49.8667L28.6414 48.0885L24.8366 49.0316L24.2899 46.8264L28.7004 45.7331L28.2192 43.7918L21.5413 45.4472L24.0436 55.5417ZM31.9528 53.5729L34.0183 53.0609L33.1656 49.621C32.7326 47.8739 33.8268 46.968 35.2472 46.9126L34.6909 44.6685C33.2161 44.7704 32.4264 45.7409 32.3015 47.0658L31.8836 45.4798L30.0588 45.9321L31.9528 53.5729ZM41.0109 51.4924C42.7813 51.0535 43.8624 49.8954 43.8038 48.1626L41.9815 48.3258C41.9606 49.0728 41.5114 49.555 40.5796 49.786C39.6013 50.0285 38.8512 49.5963 38.4129 48.5263L43.6776 47.2213C43.6432 46.9496 43.599 46.738 43.547 46.5284C42.9638 44.1756 41.2238 43.0079 38.9797 43.5642C36.6812 44.1339 35.643 46.1963 36.2069 48.4715C36.7824 50.7932 38.596 52.091 41.0109 51.4924ZM38.1032 47.2102C38.0315 46.1565 38.5044 45.4706 39.3974 45.2492C40.267 45.0336 40.9997 45.396 41.3412 46.4076L38.1032 47.2102ZM49.3522 49.4247C51.1226 48.9859 52.2037 47.8278 52.1451 46.095L50.3228 46.2582C50.3019 47.0052 49.8527 47.4874 48.9209 47.7184C47.9426 47.9609 47.1925 47.5287 46.7542 46.4587L52.0189 45.1537C51.9845 44.882 51.9403 44.6704 51.8883 44.4607C51.3051 42.1079 49.5651 40.9403 47.321 41.4966C45.0225 42.0663 43.9843 44.1287 44.5482 46.4038C45.1237 48.7256 46.9373 50.0234 49.3522 49.4247ZM46.4445 45.1425C46.3728 44.0888 46.8457 43.4029 47.7387 43.1816C48.6083 42.966 49.3411 43.3283 49.6825 44.3399L46.4445 45.1425ZM53.6307 44.853L55.37 44.4219L53.8919 37.4281L51.6711 37.9786L53.6307 44.853ZM53.644 46.935C53.8287 47.6804 54.5982 48.1244 55.3203 47.9454C56.0424 47.7664 56.5154 47.0145 56.3307 46.269C56.1478 45.5314 55.3784 45.0874 54.6562 45.2664C53.9341 45.4454 53.4611 46.1973 53.644 46.935Z"
            fill="#FFFFFF"
          />
        </svg>
        <h3>No Credit Card Required!</h3>
        <p>
          You’ll be able to receive job offers immediately, and you’ll only start paying when you’re
          ready to accept an offer.
        </p>
      </div>
      <div class="onboarding-callout-vertical card-v2 mt-24">
        <svg
          width="102"
          height="111"
          viewBox="0 0 102 111"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <defs>
            <radialGradient
              cx="4.901%"
              cy="93.866%"
              fx="4.901%"
              fy="93.866%"
              r="176.416%"
              gradientTransform="matrix(.56667 -.6068 .82395 .41733 -.752 .577)"
              id="c"
            >
              <stop stop-opacity=".35" offset="0%" />
              <stop stop-color="#FFF" offset="100%" />
            </radialGradient>
            <radialGradient
              cx="-185.357%"
              cy="506.207%"
              fx="-185.357%"
              fy="506.207%"
              r="937.156%"
              gradientTransform="scale(.86421 1) rotate(-54.96 -2 5.342)"
              id="d"
            >
              <stop offset="0%" />
              <stop stop-color="#FFF" stop-opacity="0" offset="100%" />
            </radialGradient>
            <path
              d="M42.022 1.805s2.718-2.26 6.268.176 1.905 5.939 1.905 5.939L8.721 68.353s-2.264 1.419-5.397-.9C.399 65.288.548 62.238.548 62.238L42.022 1.805z"
              id="a"
            />
            <path
              d="M42.022 1.805s2.718-2.26 6.268.176 1.905 5.939 1.905 5.939L8.721 68.353s-2.264 1.419-5.397-.9C.399 65.288.548 62.238.548 62.238L42.022 1.805z"
              id="e"
            />
          </defs>
          <g fill="none" fill-rule="evenodd">
            <circle fill="#DBF2FF" fill-rule="nonzero" cx="38.501" cy="56.5" r="36" />
            <path
              d="M38.692 10.65c.072-1.04 1.487-1.29 1.911-.338l3.224 7.24a1 1 0 00.845.591l7.906.549c1.04.072 1.29 1.487.338 1.91l-7.24 3.225a1 1 0 00-.591.844l-.549 7.907c-.072 1.04-1.487 1.29-1.91.337l-3.225-7.24a1 1 0 00-.844-.59l-7.907-.55c-1.04-.071-1.29-1.486-.337-1.91l7.24-3.224a1 1 0 00.59-.845l.549-7.906z"
              fill="#EFA747"
              fill-rule="nonzero"
            />
            <path
              d="M14.292 39.488c.56-.878 1.922-.422 1.84.617l-.478 6.019a1 1 0 00.46.922l5.091 3.245c.879.56.422 1.923-.616 1.84l-6.02-.477a1 1 0 00-.922.46l-3.245 5.091c-.56.879-1.922.422-1.84-.616l.478-6.02a1 1 0 00-.46-.922L3.49 46.402c-.879-.56-.422-1.923.616-1.84l6.02.478a1 1 0 00.922-.46l3.245-5.092z"
              fill="#00D7C2"
              fill-rule="nonzero"
            />
            <path
              d="M93.667 31.867c.148-1.031 1.577-1.177 1.93-.196l1.058 2.936a.998.998 0 00.799.65l3.089.444c1.031.148 1.177 1.578.197 1.931l-2.937 1.058a1 1 0 00-.651.798l-.443 3.09c-.148 1.03-1.578 1.177-1.93.196l-1.058-2.936a1 1 0 00-.799-.651l-3.09-.443c-1.03-.148-1.176-1.578-.196-1.931l2.936-1.058a1 1 0 00.651-.798l.444-3.09z"
              fill="#ED2644"
              fill-rule="nonzero"
            />
            <path
              d="M77.595 34.39c.594-.856 1.938-.347 1.815.688L78.007 46.88a1 1 0 00.422.94l9.765 6.774c.856.594.347 1.938-.688 1.815l-11.802-1.403a1 1 0 00-.94.423l-6.774 9.765c-.594.856-1.938.346-1.815-.688l1.404-11.802a1 1 0 00-.423-.94L57.39 44.99c-.856-.594-.347-1.937.688-1.814l11.802 1.403a1 1 0 00.94-.423l6.774-9.765z"
              fill="#004ADB"
              fill-rule="nonzero"
            />
            <path
              d="M77.363.896c.627-.832 1.95-.27 1.786.759L77.99 8.958a1 1 0 00.386.955l5.906 4.45c.832.627.27 1.95-.759 1.786l-7.303-1.16a1 1 0 00-.955.387l-4.45 5.906c-.626.832-1.95.27-1.786-.759l1.16-7.303a1 1 0 00-.386-.955l-5.906-4.45c-.833-.627-.271-1.95.758-1.786l7.303 1.16a1 1 0 00.956-.387L77.363.896z"
              fill="#8D05FB"
              fill-rule="nonzero"
            />
            <g transform="translate(0 42)">
              <mask id="b" fill="#fff">
                <use xlink:href="#a" />
              </mask>
              <g mask="url(#b)" fill-rule="nonzero">
                <path
                  d="M42.022 1.805s2.718-2.26 6.268.176 1.905 5.939 1.905 5.939L8.721 68.353s-2.264 1.419-5.397-.9C.399 65.288.548 62.238.548 62.238L42.022 1.805z"
                  fill="#140047"
                />
                <path
                  d="M42.022 1.805s2.718-2.26 6.268.176 1.905 5.939 1.905 5.939L8.721 68.353s-2.264 1.419-5.397-.9C.399 65.288.548 62.238.548 62.238L42.022 1.805z"
                  fill-opacity=".44"
                  fill="url(#c)"
                  style="mix-blend-mode: overlay"
                />
                <path
                  d="M36.776 7.88s4.446-2.261 7.996.175c3.55 2.436 1.905 5.939 1.905 5.939l-3.503 4.843s-.264-2.58-3.398-4.9c-2.924-2.165-6.503-1.214-6.503-1.214l3.503-4.843z"
                  fill="#140047"
                />
                <path
                  d="M36.776 7.88s4.446-2.261 7.996.175c3.55 2.436 1.905 5.939 1.905 5.939l-3.503 4.843s-.264-2.58-3.398-4.9c-2.924-2.165-6.503-1.214-6.503-1.214l3.503-4.843z"
                  fill-opacity=".2"
                  fill="url(#d)"
                  style="mix-blend-mode: overlay"
                />
                <path
                  d="M36.776 7.88s4.446-2.261 7.996.175c3.55 2.436 1.905 5.939 1.905 5.939l-3.503 4.843s-.264-2.58-3.398-4.9c-2.924-2.165-6.503-1.214-6.503-1.214l3.503-4.843z"
                  fill="#EEEDF2"
                />
              </g>
            </g>
          </g>
        </svg>
        <h3>Have Questions?</h3>
        <p>Not sure which role to choose? Let us help by asking you a few simple questions.</p>
        <ModalButton
          v-model="showWizard"
          class="btn"
          modal-class="onboarding-wizard"
        >
          <template #button>Begin</template>
          <template #modal-content>
            <template v-if="wizardStep === 0">
              <h2 class="onboarding-wizard-question">
                Do you have your own photography equipment, have a portfolio to show and the
                experience to work on your own?
              </h2>
              <div class="onboarding-wizard-choices">
                <OnboardingChoiceButton @click="wizardStep = 1">Yes</OnboardingChoiceButton>
                <OnboardingChoiceButton @click="suggestPlan('assistant')">
                  No
                </OnboardingChoiceButton>
              </div>
            </template>
            <template v-else>
              <h2 class="onboarding-wizard-question">
                Do you have four or more years of experience working as a lead shooter for your
                own clients handling the process from start to finish?
              </h2>
              <div class="onboarding-wizard-choices">
                <OnboardingChoiceButton @click="suggestPlan('lead-shooter')">
                  Yes
                </OnboardingChoiceButton>
                <OnboardingChoiceButton @click="suggestPlan('second-shooter')">
                  No
                </OnboardingChoiceButton>
				<button class="btn btn-large" @click="wizardStep--">Back</button>
              </div>
            </template>
          </template>
        </ModalButton>
      </div>
    </template>
  </OnboardingStep>
</template>

<script>
import { toString } from '@/helpers/convert';
import onboarding from '@/mixins/onboarding';
import SubscriptionLevel from '@/models/SubscriptionLevel';

export default {
  name: 'OnboardingRole',
  mixins: [onboarding],
  onboardingStep: {
    isApplicable: ({ isUpgrading, user }) => isUpgrading || !user,
    isCompleted: ({ isUpgrading, plan }) => plan && (!isUpgrading || plan.canBeHired),
    requires: ({ originalPlan }) => !originalPlan || !originalPlan.canBeHired,
  },
  data() {
    return {
      /** @type {boolean} */
      showBenefitsModal: false,
      /** @type {boolean} */
      showWizard: false,
      /** @type {SubscriptionLevel | null} */
      suggestedPlan: null,
      /** @type {number} */
      wizardStep: 0,
    };
  },
  computed: {
    /**
     * @returns {Intl.NumberFormat['format']}
     */
    formatCurrency() {
      return this.$getCurrencyFormat().format;
    },
    /**
     * @returns {Intl.NumberFormat['format']}
     */
    formatPercentage() {
      return this.$getNumberFormat({ style: 'percent' }).format;
    },
    /**
     * @returns {readonly SubscriptionLevel[]}
     */
    plans() {
      /** @type {readonly SubscriptionLevel[] | null} */
      let plans = this.$store.getters['subscriptions/levels'];
      if (!plans) {
        plans = [];
      } else {
        plans = plans.filter((plan) => !plan.isFree);
        const suggested = this.suggestedPlan;
        if (suggested) {
          // The recommended plan should be at the top of the list
          plans = plans.sort((a, b) =>
            a.roleId === suggested.roleId ? -1 : b.roleId === suggested.roleId ? 1 : 0
          );
        }
      }
      return Object.freeze(plans);
    },
    selectedPlan: {
      /**
       * @returns {SubscriptionLevel | null}
       */
      get() {
        /** @type {SubscriptionLevel | null} */
        const plan = this.$store.getters['onboarding/plan'];
        return plan && plan.canBeHired ? plan : null;
      },
      /**
       * @param {SubscriptionLevel | null} value
       * @returns {void}
       */
      set(value) {
        this.$store.commit('onboarding/setPlan', value);
      },
    },
    /**
     * @returns {number}
     */
    selectedPlanIndex() {
      /** @type {SubscriptionLevel | null} */
      let plan;
      const plans = this.plans;
      if (!plans || !plans.length || !(plan = this.selectedPlan)) {
        return -1;
      }
      return plans.indexOf(plan);
    },
  },
  methods: {
    /**
     * @returns {boolean}
     */
    commit() {
      if (this.selectedPlan) {
        return true;
      }
      /** @type {HTMLInputElement} */
      const input = this.$refs.planInputs[0];
      input.setCustomValidity('Please select a plan to continue.');
      input.reportValidity();
      input.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return false;
    },
    /**
     * @param {SubscriptionLevel} plan
     * @returns {string}
     */
    getPlanDescription(plan) {
      return toString(plan.longDescription || plan.description).trim();
    },
    /**
     * @param {SubscriptionLevel} plan
     * @returns {string | null}
     */
    getPlanDescriptionId(plan) {
      return (this.getPlanDescription(plan) && this.getPlanElementId(plan, 'description')) || null;
    },
    /**
     * @param {SubscriptionLevel} plan
     * @param {string | null} [suffix]
     * @returns {string}
     */
    getPlanElementId(plan, suffix) {
      if ((suffix = toString(suffix).trim())) {
        suffix = `-${suffix}`;
      } else {
        suffix = '';
      }
      return `${this.$componentId}-plan-${plan.roleId}${suffix}`;
    },
    /**
     * @param {SubscriptionLevel} plan
     * @returns {string}
     */
    getPlanInputId(plan) {
      return this.getPlanElementId(plan);
    },
    /**
     * @param {SubscriptionLevel} plan
     * @returns {string}
     */
    getPlanNameId(plan) {
      return this.getPlanElementId(plan, 'name');
    },
    /**
     * @returns {void}
     */
    launchBenefitsModal() {
      this.showBenefitsModal = true;
    },
    /**
     * @param {any} plan
     * @returns {void}
     */
    suggestPlan(plan) {
      const level = SubscriptionLevel.from(plan);
      this.showWizard = false;
      this.selectedPlan = level;
      this.suggestedPlan = level;
      document.body.scrollIntoView({ block: 'start', behavior: 'smooth' });
    },
  },
  created() {
    this.$store.dispatch('subscriptions/getLevels');
  },
  watch: {
    selectedPlan() {
      this.$refs.planInputs[0].setCustomValidity('');
    },
    selectedPlanIndex(index) {
      this.$store.commit('onboarding/setPlanIndex', index);
    },
    showWizard(visible) {
      if (visible) {
        this.wizardStep = 0;
      }
    },
  },
};
</script>
